import { BookButton } from '../../components/BookButton';
import { useOfferContext } from '../OfferContext';
import { useMemo } from 'react';

export const BookButtonContainer = () => {
  const { canBeBooked, href } = useOfferContext();

  const buttonTitle = useMemo(() => (canBeBooked ? 'Бронировать онлайн' : 'Проверить места'), [canBeBooked]);

  return <BookButton title={buttonTitle} offerUrl={href} />;
};
